<div class="top-bar">
  <h1 class="top-bar__title">{{ 'CONTAINERS.LABEL' | translate }}</h1>
  <app-select-market></app-select-market>
</div>

<div class="page">
  <div class="page-toolbar">
    <div class="page-toolbar__start search">
      <df-input type="search" block prefixIcon="heroMagnifyingGlass" allowClear [placeholder]="'UI.SEARCH.CONTAINER' | translate"
        [value]="textFilter" (valueChange)="textFilter = $event; filterContainers()" />
    </div>
    <div class="page-toolbar__end">
      <df-button variant="primary" icon="heroPlus" (onClick)="openContainerModal()">{{ 'CONTAINER.NEW' | translate }}</df-button>
    </div>
  </div>

  @if (selectedMarket) {
    <div class="card">
      @if (displayedContainers?.length) {
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'CONTAINER.ACTIVATED' | translate }}</th>
              <th>{{ 'PRODUCT.CONTAINER' | translate }}</th>
              <th>{{ 'CONTAINER.CAPACITY' | translate }} ({{ selectedMarket.volumeUom }})</th>
              <th>{{ 'CONTAINER.PRESSURE' | translate }} ({{ selectedMarket.pressureUom }})</th>
              <th>{{ 'CONTAINER.EMPTY_TARE' | translate }} ({{ selectedMarket.weightUom }})</th>
              <th>{{ 'CONTAINER.TRANSPORT_COMPANY' | translate }}</th>
              <th>{{ 'CONTAINER.MODEL_NAME' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (container of paginatedContainers; track container) {
              <tr [class.inactive]="!container.isActivated">
                <td>
                  <input type="checkbox" class="switch"
                    [checked]="container.isActivated"
                    (change)="toggleContainerActivation(container)"/>
                </td>
                <td class="cell-strong">{{ container.containerId }}</td>
                <td>{{ container.containerMaxCapacity | number : '1.0-0' }}</td>
                <td>{{ container.containerMAWP | number : '1.0-2' }}</td>
                <td>{{ container.containerTareWeight | number : '1.0-0' }}</td>
                <td>{{ container.transportcompanyName }}</td>
                <td>{{ container.containermodelName }}</td>
                <td class="cell-actions">
                  <button type="button" class="icon-action danger" title="Delete" (click)="removeContainer(container)">
                    <ng-icon name="heroTrash" size="18"/>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
        @if (displayedContainers.length > pageSize) {
          <div class="pagination" aria-label="Container pages">
            <span class="pagination__summary">Page {{ currentPage }} of {{ pageCount }}</span>
            <div class="pagination__actions">
              <button type="button" class="pagination__button" [disabled]="currentPage === 1"
                aria-label="Previous page" (click)="setPage(currentPage - 1)">Previous</button>
              <button type="button" class="pagination__button" [disabled]="currentPage === pageCount"
                aria-label="Next page" (click)="setPage(currentPage + 1)">Next</button>
            </div>
          </div>
        }
      } @else {
        <div class="empty-state">
          <ng-icon name="heroTruck" size="32"/>
          <div class="empty-state__title">{{ 'UI.EMPTY.CONTAINERS' | translate }}</div>
          <div class="empty-state__text">{{ 'UI.EMPTY.CONTAINERS_MARKET' | translate }}</div>
        </div>
      }
    </div>
  }
</div>

@if (addingContainer) {
  <app-create-container
    [market]="selectedMarket"
    (closeModal)="closeContainerModal($event)">
  </app-create-container>
}
